import { type RecipientResponse, TransferRecipientTypeEnum } from '@shared/api/rest/recipients';
import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface RecipientInfoProps {
  className?: string;
  recipient: RecipientResponse;
}

export const RecipientInfo = (props: RecipientInfoProps) => {
  return (
    <section className={cn('flex flex-col gap-6', props.className)}>
      <div
        className={cn('flex gap-2 bg-white p-4 dark:bg-soft-black', PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black')}
      >
        <div className='flex h-12 w-12 items-center justify-center bg-black'>
          <Text weight='semibold' size='xl' color='white'>
            {props.recipient.type === TransferRecipientTypeEnum.Individual &&
              !!props.recipient.firstName.length &&
              props.recipient.firstName[0].toUpperCase()}
            {props.recipient.type === TransferRecipientTypeEnum.Business &&
              !!props.recipient.companyName.length &&
              props.recipient.companyName
                .trim()
                .split(' ')
                .map((word) => (word?.[0] || '').toUpperCase())
                .join('')}
          </Text>
        </div>
        <div>
          {props.recipient.type === TransferRecipientTypeEnum.Individual && (
            <Text weight='semibold' size='xl'>
              {props.recipient.firstName} {props.recipient.lastName}
            </Text>
          )}
          {props.recipient.type === TransferRecipientTypeEnum.Business && (
            <Text weight='semibold' size='xl'>
              {props.recipient.companyName}
            </Text>
          )}
          <Text weight='semibold' size='xs' color='gray' uppercase>
            {props.recipient.iban || props.recipient.accountNumber}
          </Text>
        </div>
      </div>
    </section>
  );
};
